import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getCircular } from "../Service/Api";

const AdmissionResult = () => {
  const [admissionResult, setAdmissionResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function getCircularData() {
      try {
        const response_result = await getCircular();
        const response_result_cat = response_result.filter(
          (item) => item.category === "Admission"
        );
        setAdmissionResult(response_result_cat);
      } catch (error) {
        console.error("this is an error", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    }
    getCircularData();
  }, []);

  if (loading)
    return (
      <div className="container">
        <p>Loading...</p>
      </div>
    );
  if (error)
    return (
      <div className="container">
        <p>Error: {error.message}</p>
      </div>
    );

  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Admission Result</li>
          <li> Admission Result </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container" id="admission_result_container_id">
          <div className="row">
            <div className="col-lg-12">
              <h1> Admission Result </h1>
            </div>
          </div>

          <div className="row">
            {admissionResult.length > 0 ? (
              admissionResult.map((item) => (
                <div
                  key={item.id}
                  className="col-lg-3 col-md-6 col-sm-12 col-12">
                  <div className="admission_result_container_block">
                    <div className="admission-card-header">
                      <span className="badge">
                        {new Date(item.date).toLocaleDateString("en-GB")}
                      </span>
                    </div>
                    <div className="admission-card-body">
                      <h5>{item.title}</h5>
                      {item.attachments && item.attachments.length > 0 ? (
                        <a
                          href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn-modern">
                          View Results
                        </a>
                      ) : (
                        <p className="text-muted">No attachments available.</p>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-lg-12">
                <p>No admission results available.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdmissionResult;
